<template>
  <div v-if="data" class="basic-select" :style="formSize" :class="additionalCss">
    <select required :name="name" v-on:change="updateValue" v-model="selected" :disabled="isDisable">
      <option v-if="placeholder" disabled value="placeholder">{{placeholder}}</option>
      <option v-for="(item, subIndex) in data" :key="subIndex" :value="item.value">
        {{item.label}}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: ['name', 'data', 'default', 'size', 'placeholder', 'isDisable', 'isError'],
  data () {
    return {
      selected: null,
      defaultSize: 300,
    };
  },
  watch: {
    '$route' () {
      this.initialize();
    },
    data: function () {
      this.initialize();
    },
    default: function () {
      this.initialize();
    }
  },
  mounted: function () {
    this.initialize();
  },
  computed: {
    formSize: function () {

      let w = this.$store.getters['wrm/width'];
      // console.log(w, this.$variables.mediaScreenIsPC);

      if(w <= this.$variables.mediaScreenIsPC){
        return 'width: 100%'
      } else{

        let size = parseInt(this.size);
        // console.log(size);

        if(isNaN(size)){
          return 'width:' + this.defaultSize + 'px';
        } else {
          return 'width:' + size + 'px';
        }

      }
    },
    additionalCss: function () {

      let css = [];

      if (this.isDisable) {
        css.push('is-disable');
      } else {
        css.push('cursor-pointer');
      }

      if (this.isError) {
        css.push('is-error');
      }

      if (this.$isAdmin()) {
        css.push('border-default');
      } else {
        css.push('border-front');
      }

      return css;
    }
  },
  methods: {
    initialize: function () {

      if (this.data == null) {
        return;
      }

      let value = {key: this.name, value: this.default};

      this.$store.dispatch('formValues/setFormData', value).then();

      if (typeof this.default === 'undefined' || this.default === '') {
        this.selected = 'placeholder';
      } else {
        this.selected = this.default;
      }

    },
    updateValue: function (e) {

      let value = {key: this.name, value: e.target.value};

      this.$store.dispatch('formValues/setFormData', value).then();

    }
  }
};
</script>

<style lang="scss" scoped>

  @import '../../assets/styles/_variable.scss';

  .basic-select {
    background: #fff;
    border: 1px solid #979797;
    overflow: hidden;
    height: 36px;
    line-height: 34px;
    text-align: center;
    font-size: 14px;
    position: relative;
    border-radius: 4px;
  }

  .basic-select::before {
    position: absolute;
    top: 14px;
    right: 10px;
    width: 0;
    height: 0;
    padding: 0;
    content: '';
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 9px solid #666666;
    pointer-events: none;
  }

  .basic-select select {
    width: 100%;
    text-overflow: ellipsis;
    border: none;
    outline: none;
    background: transparent none;
    box-shadow: none;
    -webkit-appearance: none;
    padding: 0 38px 0 15px;
  }

  /** use computed */
  .is-disable {
    background: #f8f8f8;
    color: #444;
  }

  .is-error {
    height: 38px;
    top: -1px;
    left: -1px;
    border: 1px solid #DD4B39;
    background: rgba(237, 159, 150, 0.28);
    color: #DD4B39;
  }

  .cursor-pointer select {
    cursor: pointer;
  }

  /** ---- **/

  .border-front {
    border: solid 1px $frontFormBorder;
  }

  .border-default {
    border: solid 1px #979797;
  }

</style>
